// Hover accent for the "try one of these:" suggestion chips — the /apps
// quick-start box and every import dialog. One step further from the page
// background than info.main: darker on light, brighter on dark. The palette's
// dark/light variants are MUI's hover-emphasis pattern; `emphasize()` is the
// wrong tool here because it keys off the colour's own luminance and so
// lightens info.main. Usable directly as an sx value (`color: chipHoverAccent`).
export const chipHoverAccent = theme =>
    theme.palette.mode === 'dark'
        ? theme.palette.info.light
        : theme.palette.info.dark

const getThemeOptions = isDarkMode => ({
    palette: {
        mode: isDarkMode ? 'dark' : 'light',
        background: {
            default: isDarkMode ? '#333333' : '#f0ecec',
            dialogs: isDarkMode ? '#1e1e1e' : '#fdf6f6',
            selectors: isDarkMode ? '#000000' : '#f0ecec',
            text: isDarkMode ? '#aaaab5' : 'black',
            button: isDarkMode ? '#1e1e1e' : 'rgba(255, 255, 255, 0.9)',
        },
        actionButton: {
            background: {
                ai: isDarkMode ? '#b7c5ff' : '#5063b5',
                market: isDarkMode ? '#b7dbff' : '#548fd3',
            },
            hover: {
                ai: isDarkMode ? '#a5b3de' : '#4255a8',
                market: isDarkMode ? '#a5d3de' : '#2a79ae',
            },
        },
        colors: {
            white: '#fff',
            icons: isDarkMode ? '#cccccc' : 'black',
            chip: isDarkMode ? '#AAAAFA' : 'black',
        },
        // primary: {
        //     main: '#98aafb',
        //     light: '#747c9e',
        // },
        // secondary: {
        //     main: '#f50057',
        // },
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiTooltip: {
            defaultProps: {
                arrow: false,
            },
        },
        MuiToolbar: {
            styleOverrides: {
                dense: {
                    height: '48px',
                    minHeight: '48px',
                },
            },
        },
    },
    typography: {
        button: {
            textTransform: 'none',
        },
        overline: {
            textTransform: 'none',
        },
        h4: {
            fontSize: '1.5rem',
        },
        h6: {
            color: isDarkMode ? '#aaaab5' : '#000000',
        },
    },
})

export default getThemeOptions
